export const SLUGS = {
  vehiclesCatalog: 'Vehicles Catalog',
  careers: 'Careers',
  privacyPolicy: 'Privacy Policy',
  registerToBid: 'Register To Bid',
  FAQ: 'FAQ',
  termsAndConditions: 'Terms & Conditions',
  consignment: 'Consignment',
};
